<script>import { onMount } from "svelte";
import { currentUser, clientWebsite } from "./stores";
import { NotificationDisplay } from "@shopboxai/sb-portal-components";
import Admin from "./components/Admin.svelte";
export let user;
export let website = "";
let mounted = false;
onMount(() => {
    currentUser.set(user);
    if (website) {
        const dashPosition = website.lastIndexOf("-");
        if (dashPosition >= 0) {
            clientWebsite.set(website.slice(dashPosition + 1));
        }
    }
    mounted = true;
});
</script>

{#if mounted}
  <main>
    <h1>Admin</h1>
    <Admin />
    <NotificationDisplay />
  </main>
{/if}

<style>:global(*){box-sizing:border-box;margin:0}:global(html,body){font-family:Overpass,sans-serif;height:100%;width:100%}h1{color:#05126d;flex:none;flex-grow:0;font-family:Chivo,sans-serif;font-size:34px;font-weight:900;letter-spacing:.5px;line-height:40px;order:1}main{margin:0 auto;max-width:1200px;position:relative;width:100%}</style>
